/**
 * Default configuration for Ashtamsha (D8) Chakra
 * Centralized defaults for consistency across the application
 */

import { FONTS } from './fonts';

/**
 * Default visibility state for Ashtamsha Chakra
 * @returns boolean - default visibility (false to match muhurta chakra)
 */
export function getDefaultAshtamshaChakraVisibility(): boolean {
    return false; // Hidden by default, user can enable
}

/**
 * Default configuration for Ashtamsha Chakra rendering
 */
export const ASHTAMSHA_CHAKRA_DEFAULTS = {
    // Visibility
    defaultVisible: false,

    // Division settings
    totalSectors: 8,                    // 8 divisions
    degreesPerSector: 45,              // 360° / 8 = 45° per sector

    // Display settings
    showSectorNumbers: true,           // Show sector numbers (1-8)
    showRulerCodes: true,             // Show 2-letter ruler codes (Sy, Ch, etc.)
    showRulerNames: false,            // Don't show full names by default

    // Positioning
    startFromSunrise: true,           // Position relative to sunrise
    clockwiseDirection: true,         // Traditional clockwise direction

    // Animation
    enableAnimations: true,           // Enable hover/click animations
    transitionDuration: 300,          // Animation duration in ms

    // Layer settings
    layerName: 'ashtamsha-sectors-layer',
    zIndex: 100,                      // Above background, below planets

    // Event names
    toggleEventName: 'ashtamsha.sectors.toggle',
    dataEventName: 'ashtamsha.data.updated'
} as const;

/**
 * Default Ashtamsha sector configuration
 */
export const DEFAULT_ASHTAMSHA_SECTOR_CONFIG = {
    // Visual styling comes from chartColorPresets
    strokeWidth: 1,
    opacity: 0.7,
    hoverOpacity: 0.9,

    // Text positioning
    textOffset: 0.5,                  // Position in middle of sector
    fontSize: '12px',
    fontFamily: FONTS.chart.primary,

    // Sector boundaries
    showBoundaries: true,
    boundaryStroke: '#666',
    boundaryWidth: 1
} as const;